import React from 'react';
import AboutUs from '../components/AboutUs';
import Achievement from '../components/Achievement';
import OurServices from '../components/OurServices';
import Footer from '../components/Footer';
import NavHero from '../components/Navbar';

const Home = () => {
  return (
    <>
      <NavHero />
      <AboutUs />
      <Achievement />
      <OurServices />
      <Footer />
    </>
  );
};

export default Home;
